import React, { FunctionComponent, ReactChild, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { IS_PRODUCTION } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/constants'
import { PRODUCT_TYPE } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/productType'
import { getProductTypeProviderValues } from '@lyrahealth-inc/shared-app-logic/src/features/common/utils/productTypeProviderUtils'
import { useFlags } from '@lyrahealth-inc/shared-app-logic/src/features/flags/useFlags'
import { LYRA_THEME_STORAGE_KEY } from '@lyrahealth-inc/ui-core-crossplatform/src/constants'
import { ProductTypeContext } from '@lyrahealth-inc/ui-core-crossplatform/src/utils/productType/productTypeContext'

import { LOG_CATEGORY, logToSentry } from '../../common/utils/userUtils'
import { getCustomerProductType } from '../../data/customer/customerSelectors'
import { getId } from '../../data/user/userSelectors'

export const ProductTypeProvider: FunctionComponent<{
  children: ReactChild | ReactChild[]
}> = ({ children }) => {
  const { isWellbeingEnabled } = useFlags()
  const productType = useSelector(getCustomerProductType)
  const lyraId = useSelector(getId)
  const {
    isLyraSelect,
    isWellbeing,
    productType: computedProductType,
  } = getProductTypeProviderValues({
    isWellbeingEnabled,
    productType,
  })

  const [essentialsTheme, setEssentialsTheme] = useState<string | null>(null)

  useEffect(() => {
    let storedTheme: string | null = null
    try {
      storedTheme = localStorage.getItem(LYRA_THEME_STORAGE_KEY)
    } catch (e) {
      console.error('Failed to read theme from localStorage', e)
      logToSentry(IS_PRODUCTION ? LOG_CATEGORY.PROD_DEBUG : LOG_CATEGORY.STAGING_DEBUG, {
        userId: lyraId,
        message: 'Failed to read theme from localStorage',
        type: 'error',
        error: e,
      })
    }
    const themeMode = storedTheme === 'dark' ? 'dark' : 'light'
    setEssentialsTheme(computedProductType === PRODUCT_TYPE.SELECT ? 'wfmh' : `aurora_${themeMode}`)
  }, [computedProductType, lyraId])

  return (
    <ProductTypeContext.Provider
      value={{
        isLyraSelect,
        isWellbeing,
        productType: computedProductType,
        essentialsTheme,
        setEssentialsTheme,
      }}
    >
      {children}
    </ProductTypeContext.Provider>
  )
}
